import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCallback } from "react";
// import { createGenerationRule, updateGenerationRuleById, getGenerationRuleById } from "../../../../../services/generationRule.service";
import {
  TGenerationRuleForm,
  generationRuleSchema,
} from "./generationRuleSchema";
import {
  AutoComplete,
  FormContainer,
  FormInput,
  FormTabs,
  Treturn,
  useNotificationContext,
} from "@4uhub/lib4uhub";
import { dataOrigins, generationRuleItems } from "../generation-rule.mock";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import BadgeIcon from "@mui/icons-material/Badge";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import ScheduleIcon from "@mui/icons-material/Schedule";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { IndividualPage } from "./Individual/IndividualPage";
import { EmployeePage } from "./Employee/EmployeePage";
import { DoctorPage } from "./Doctor/DoctorPage";
import { BeneficiaryPage } from "./Beneficiary/BeneficiaryPage";
import { SchedulePage } from "./Schedule/SchedulePage";
import { ServicePeriodPage } from "./ServicePeriod/ServicePeriodPage";

const translationPath = "page.4uDlist.generationRule.";

const GenerationRule = () => {
  const navigate = useNavigate();

  const { eI, id } = useParams();

  const { t } = useTranslation();

  const { setMessage } = useNotificationContext();

  const [searchParams, setSearchParams] = useSearchParams();

  //   const { sendRequest: save, loading: sLoading } = useFetch(
  //     createGenerationRule
  //   );

  //   const { sendRequest: update, loading: uLoading } = useFetch(
  //     updateGenerationRuleById
  //   );

  //   const { sendRequest: get, loading: gLoading } = useFetch(
  //     getGenerationRuleById
  //   );

  const saveHandler = async (v: TGenerationRuleForm) => {
    // save({
    //   ...v,
    // });
    const lastItemId = generationRuleItems[generationRuleItems.length - 1]?.id;
    const id = parseInt(lastItemId) + 1;
    return { data: { id }, success: true };
  };

  const updateHandler = async (v: TGenerationRuleForm, id: string) => {
    // update({
    //   item: {
    //     ...v,
    //   },
    //   id: id,
    // });
    return { data: {}, success: true };
  };

  const getHandler = useCallback(
    async (id: string): Promise<Treturn<TGenerationRuleForm>> => {
      //   const { data, success } = await get(id);
      //   if (data && success) {
      //     const newData: TGenerationRuleForm = {
      //       ...data,
      //     };
      //     return { data: newData, success: true };
      //   }

      const data = generationRuleItems.find((item) => item.id === id);
      if (data) {
        return { data, success: true };
      }

      return { data: null, success: false };
    },
    [],
  );

  const redirectOnSuccess = useCallback(
    (data?: TGenerationRuleForm) => {
      if (!id) {
        if (data) {
          setMessage({
            message: t(translationPath + "created_successfully"),
            type: "success",
          });
          setSearchParams({ id: data.id! });
          //   navigate(
          //     `/e/${eI}/4uDlist/listsGenerator/generationRule/${data.id}/edit`,
          //     {
          //       replace: true,
          //     },
          //   );
        }
      } else {
        navigate(`/e/${eI}/4uDlist/listsGenerator/generationRule/`, {
          replace: true,
        });
      }
    },
    [navigate, setMessage, t, id, eI],
  );

  const mockId = searchParams.get("id") ?? id;

  let tabs = [
    {
      label: t(translationPath + "individual_title"),
      icon: <PersonIcon fontSize="small" />,
      component: <IndividualPage />,
    },
    {
      label: t(translationPath + "employee_title"),
      icon: <BadgeIcon fontSize="small" />,
      component: <EmployeePage />,
    },
    {
      label: t(translationPath + "doctor_title"),
      icon: <MedicalServicesIcon fontSize="small" />,
      component: <DoctorPage />,
    },
    {
      label: t(translationPath + "beneficiary_title"),
      icon: <AssignmentIndIcon fontSize="small" />,
      component: <BeneficiaryPage />,
    },
    {
      label: t(translationPath + "schedule_title"),
      icon: <ScheduleIcon fontSize="small" />,
      component: <SchedulePage />,
    },
    {
      label: t(translationPath + "service_period_title"),
      icon: <CalendarMonthIcon fontSize="small" />,
      component: <ServicePeriodPage />,
    },
  ];

  return (
    <>
      <FormContainer<TGenerationRuleForm>
        saveFunction={saveHandler}
        updateFunction={updateHandler}
        getFunction={getHandler}
        //   loading={loading}
        title={t(translationPath + "generation_rule")}
        schema={generationRuleSchema}
        subtitle={t(translationPath + "new_generation_rule")}
        subtitleWatchField="name"
        redirectOnSave={false}
        onSuccess={redirectOnSuccess}
        formActionsOnBottom={false}
        marginBottom={5}
        customHeight="fit-content"
        fields={() => (
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormInput
                name="name"
                label={t(translationPath + "name")}
                fullWidth
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <AutoComplete
                name="dataOrigin"
                size="small"
                options={dataOrigins}
                label={t(translationPath + "data_origin")}
                getOptionLabel={(option) => option.name}
              />
            </Grid>
          </Grid>
        )}
      />
      {mockId && (
        <Grid container spacing={2} sx={{ width: "80%", margin: "0 auto" }}>
          <Grid item sm={12} mb={5}>
            <FormTabs tabs={tabs} />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default GenerationRule;
